import request from "@/utils/request";

// 分页查询名师优课
export const pageFamousCourses = (data) => {
    return request({
        url: "/businessservice/famousCourse/pageFamousCourses",
        method: "post",
        data: data
    })
}

// 查询名师优课详细信息
export const infoFamousCourse = (query) => {
    return request({
        url: '/businessservice/famousCourse/info',
        method: "get",
        params: query,
    })
}

// 查看课程数
export const viewFamousCourse = (query) => {
    return request({
        url: '/businessservice/famousCourse/view',
        method: "get",
        params: query,
    })
}

// 点赞课程数
export const likeFamousCourses = (data) => {
    return request({
        url: "/businessservice/famousCourse/like",
        method: "post",
        data: data
    })
}

// 收藏课程数
export const collectFamousCourses = (data) => {
    return request({
        url: "/businessservice/famousCourse/collect",
        method: "post",
        data: data
    })
}